"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const AbstractGridDataManager_1 = tslib_1.__importDefault(require("./AbstractGridDataManager"));
const SortComparator_1 = tslib_1.__importDefault(require("./SortComparator"));
const ReverseComparator_1 = tslib_1.__importDefault(require("./ReverseComparator"));
const SortDirection_1 = require("./model/SortDirection");
class DefaultGridDataManager extends AbstractGridDataManager_1.default {
    constructor(grid) {
        super();
        this.setGrid(grid);
    }
    sort(column, sortDirection, callDataChanged = true) {
        if (column >= 0) {
            this.sortedByColumn = column;
            this.sortDirection = sortDirection;
            let comparator;
            if (sortDirection === SortDirection_1.SortDirection.ASCENDING) {
                comparator = new SortComparator_1.default(this.grid.getGridConfig(), this);
            }
            else {
                comparator = new ReverseComparator_1.default(this.grid.getGridConfig(), this);
            }
            this.data.sort((a, b) => comparator.compare(a, b));
            if (callDataChanged) {
                this.grid.dataChanged(true);
            }
        }
    }
    setData(data) {
        this.data = data;
        this.sort(this.sortedByColumn, this.sortDirection, false);
        if (this.grid != null) {
            this.grid.dataChanged(false);
        }
    }
    clear() {
        this.data = [];
    }
}
exports.default = DefaultGridDataManager;
//# sourceMappingURL=DefaultGridDataManager.js.map